import './styles.css';
import {Spinner} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import { getStoredAuthToken, storeAuthToken } from '../../shared/utils/auth/authToken';
import {useState} from 'react';
import api from '../../shared/utils/auth/Index';
import queryString from '../../shared/utils/queryString';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faBackward, faChevronRight,
    faPhoneAlt,
    faShieldAlt,
    faSignInAlt,
    faSyncAlt,
    faUserAlt
} from "@fortawesome/free-solid-svg-icons";
import keyIcon from "../../assets/img/key.svg";
import AuthLayout from "./AuthLayout";
import {useAlert} from "react-alert";

const EnterCode = () => {
    let reactAlert = useAlert();

    const [code, setCode] = useState('');

    const [sending, setSending] = useState(false);
    const onSubmit = (e) => {
        e.preventDefault();

        if (code.trim().length === 0) {
            reactAlert.error('لطفا کد فعالسازی را وارد کنید');
            return;
        }

        setSending(true);
        validateCode();
    }

    const validateCode = () => {
        let URL = '/general/verify ';
        api.post(URL, {mobile: queryString.getParam('mobile'), code: code}, (res) => {
            let data = res.data.data;
            storeAuthToken(data.access_token)

            let getUrl = window.location;
            let baseUrl = getUrl .protocol + "//" + getUrl.host;
            window.location.replace(baseUrl);

        }, (err) => {
            console.log(err)
            setSending(false);
            reactAlert.error('کد وارد شده اشتباه می باشد.');
        });
    }


    return (
        <AuthLayout>
            <form onSubmit={(e) => onSubmit(e)}>
                <div className="row">
                    <div className="col-auto mx-auto">
                        <img src="/logo.png" alt="Logo" className="img-fluid"/>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col text-center text-white py-3">
                        کد فعالسازی به شماره
                        <span className="font-irs-b">{queryString.getParam('mobile')}</span>
                        فرستاده شد.
                    </div>
                </div>


                <div className="row font-irs-b mt-3">
                    <div className="col-auto mx-auto">
                        <div className="row">
                            <div className="col-12 pr-4">
                                کد فعالسازی
                            </div>
                        </div>

                        <div className="row align-items-center">
                            <div className="col pl-0">
                                <input type="text"
                                       value={code}
                                       onChange={(e) => setCode(e.target.value)}
                                       className="auth-input"/>
                            </div>
                            <div className="col-auto px-0">
                                <div className="auth-icon">
                                    <img src={keyIcon} className="img-fluid"/>
                                </div>
                            </div>
                        </div>

                        <div className="row align-items-center mt-4">
                            <div className="col-auto mr-auto pl-0">
                                <button className="btn auth-btn font-irs-b">تائید
                                    {sending && <Spinner animation="border"/>}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>


                <div className="row mt-2">
                    <div className="col text-center">
                        <Link to="/" className="text-white font-irs-b">
                            <FontAwesomeIcon icon={faChevronRight}/>
                            <span className="d-inline-block pr-1">بازگشت</span>
                        </Link>
                    </div>
                </div>

            </form>
        </AuthLayout>
    )
}


export default EnterCode;
